import Link from 'next/link';
import { type ComponentProps, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type TaskPaneActionLinkProps = ComponentProps<typeof Link> & {
  icon?: ReactNode;
};

export const TaskPaneActionLink = memo(({ children, className, icon, ...rest }: TaskPaneActionLinkProps) => (
  <Link
    className={cn(
      'inline-flex h-6 items-center gap-1 rounded-6 px-2 font-semibold ads:text-primary text-12 text-gray-12 ads:hover:bg-hover-subtle hover:bg-gray-5 ads:hover:text-primary hover:text-gray-12 focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9',
      className,
    )}
    {...rest}
  >
    {icon}
    {children}
  </Link>
));

TaskPaneActionLink.displayName = 'TaskPaneActionLink';
